import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ParentAppLayout from './parent-app/ParentAppLayout';
import Dashboard from './parent-app/dashboard/index';
import Curriculum from './parent-app/curriculum/index';
import Classes from './parent-app/classes/index';
import Students from './parent-app/students/index';
import StudentProfilePage from './parent-app/students/profile/StudentProfilePage';
import Teachers from './parent-app/teachers/index';
import BulkImport from './parent-app/bulk-import/index';
import Fees from './parent-app/fees/index';
import Documents from './parent-app/documents/index';
import Settings from './parent-app/settings/index';
import ClassFeed from './parent-app/class-feed/index';
import Timetable from './parent-app/timetable/index';
import Homework from './parent-app/homework/index';
import Diary from './parent-app/diary/index';
import NotificationCenter from './parent-app/notifications/index';
import Events from './parent-app/events/index';
import Leave from './parent-app/leave/index';
import HelpDesk from './parent-app/complaints/index';
import UsersRoles from './parent-app/users-roles/index';
import ChangeLogs from './parent-app/change-logs/index';
import AssessmentScheme from './parent-app/settings/assessment-scheme/index';
import Exams from './parent-app/exams/index';
import Marks from './parent-app/marks/index';
import ReportCards from './parent-app/report-cards/index';

const ParentApp: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ParentAppLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="curriculum" element={<Curriculum />} />
        <Route path="classes" element={<Classes />} />
        <Route path="students" element={<Students />} />
        <Route path="students/:uuid" element={<StudentProfilePage />} />
        <Route path="teachers" element={<Teachers />} />
        <Route path="class-feed" element={<ClassFeed />} />
        <Route path="notifications" element={<NotificationCenter />} />
        <Route path="timetable" element={<Timetable />} />
        <Route path="homework" element={<Homework />} />
        <Route path="diary" element={<Diary />} />
        <Route path="bulk-import" element={<BulkImport />} />
        <Route path="fees" element={<Fees />} />
        <Route path="documents" element={<Documents />} />
        <Route path="settings" element={<Settings />} />
        <Route path="events" element={<Events />} />
        <Route path="leave" element={<Leave />} />
        <Route path="help-desk" element={<HelpDesk />} />
        <Route path="users-roles" element={<UsersRoles />} />
        <Route path="assessment-scheme" element={<AssessmentScheme />} />
        <Route path="exams" element={<Exams />} />
        <Route path="marks" element={<Marks />} />
        <Route path="report-cards" element={<ReportCards />} />
        <Route path="change-logs" element={<ChangeLogs />} />
      </Route>
    </Routes>
  );
};

export default ParentApp;
